import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  home: {
    id: 'learner.dashboard.page.home',
    defaultMessage: 'Home',
    description: 'Home page',
  },
  discover: {
    id: 'learner.dashboard.page.discover',
    defaultMessage: 'Discover',
    description: 'Discover page',
  },
  discoverAll: {
    id: 'learner.dashboard.page.discover.all',
    defaultMessage: 'All',
    description: 'All courses',
  },
  discoverWishlist: {
    id: 'learner.dashboard.page.discover.wishlist',
    defaultMessage: 'Wishlist',
    description: 'Wishlist page',
  },
  myLearning: {
    id: 'learner.dashboard.page.my-learning',
    defaultMessage: 'My Learning',
    description: 'My Learning page',
  },
  progress: {
    id: 'learner.dashboard.page.progress',
    defaultMessage: 'Progress',
    description: 'Progress page',
  },
  schedule: {
    id: 'learner.dashboard.page.schedule',
    defaultMessage: 'Schedule',
    description: 'Schedule page',
  },
  notifications: {
    id: 'learner.dashboard.page.notifications',
    defaultMessage: 'Notifications',
    description: 'Notifications page',
  },
  support: {
    id: 'learner.dashboard.page.support',
    defaultMessage: 'Support',
    description: 'Support page',
  },
  settings: {
    id: 'learner.dashboard.page.settings',
    defaultMessage: 'Settings',
    description: 'Settings page',
  },
  helpSupport: {
    id: 'learner.dashboard.page.help-support',
    defaultMessage: 'Help & Support',
    description: 'Help & Support page',
  },
  logout: {
    id: 'learner.dashboard.page.logout',
    defaultMessage: 'Logout',
    description: 'Logout page',
  },
  home: {
    id: 'staff.dashboard.menu.home',
    defaultMessage: 'Home',
    description: 'Home menu item',
  },
  academics: {
    id: 'staff.dashboard.menu.academics',
    defaultMessage: 'Learning',
    description: 'Learning menu item',
  },
  courses: {
    id: 'staff.dashboard.menu.courses',
    defaultMessage: 'Courses',
    description: 'Courses submenu item',
  },
  programs: {
    id: 'staff.dashboard.menu.programs',
    defaultMessage: 'Programs',
    description: 'Programs submenu item',
  },
  taxonomies: {
    id: 'staff.dashboard.menu.taxonomies',
    defaultMessage: 'Taxonomies',
    description: 'Taxonomies submenu item',
  },
  library: {
    id: 'staff.dashboard.menu.library',
    defaultMessage: 'Library',
    description: 'Library menu item',
  },
  videos: {
    id: 'staff.dashboard.menu.videos',
    defaultMessage: 'Videos',
    description: 'Videos menu item',
  },
  documents: {
    id: 'staff.dashboard.menu.documents',
    defaultMessage: 'Documents',
    description: 'Documents menu item',
  },
  users: {
    id: 'staff.dashboard.menu.users',
    defaultMessage: 'Users',
    description: 'Users menu item',
  },
  allUsers: {
    id: 'staff.dashboard.menu.allUsers',
    defaultMessage: 'All',
    description: 'All users submenu item',
  },
  staffs: {
    id: 'staff.dashboard.menu.staffs',
    defaultMessage: 'Staff',
    description: 'Staffs submenu item',
  },
  learners: {
    id: 'staff.dashboard.menu.learners',
    defaultMessage: 'Learners',
    description: 'Learners submenu item',
  },
  teams: {
    id: 'staff.dashboard.menu.teams',
    defaultMessage: 'Teams',
    description: 'Teams submenu item',
  },
  analytics: {
    id: 'staff.dashboard.menu.analytics',
    defaultMessage: 'Analytics',
    description: 'Analytics menu item',
  },
  schedule: {
    id: 'staff.dashboard.menu.schedule',
    defaultMessage: 'Schedule',
    description: 'Schedule menu item',
  },
  utilities: {
    id: 'staff.dashboard.menu.utilities',
    defaultMessage: 'Utilities',
    description: 'Utilities menu item',
  },
  notifications: {
    id: 'staff.dashboard.menu.notifications',
    defaultMessage: 'Notifications',
    description: 'Notifications submenu item',
  },
  platformSettings: {
    id: 'staff.dashboard.menu.platformSettings',
    defaultMessage: 'Platform Settings',
    description: 'Platform Settings menu item',
  },
  customization: {
    id: 'staff.dashboard.menu.customization',
    defaultMessage: 'Customization',
    description: 'Customization submenu item',
  },
  integrations: {
    id: 'staff.dashboard.menu.integrations',
    defaultMessage: 'Integrations',
    description: 'Integrations submenu item',
  },
  features: {
    id: 'staff.dashboard.menu.features',
    defaultMessage: 'Features',
    description: 'Features submenu item',
  },
  billing: {
    id: 'staff.dashboard.menu.billing',
    defaultMessage: 'Billing',
    description: 'Billing menu item',
  },
  ticketing: {
    id: 'staff.dashboard.menu.ticketing',
    defaultMessage: 'Ticketing',
    description: 'Ticketing footer menu item',
  },
  support: {
    id: 'staff.dashboard.menu.support',
    defaultMessage: 'Support',
    description: 'Support footer menu item',
  },
  logout: {
    id: 'staff.dashboard.menu.logout',
    defaultMessage: 'Log out',
    description: 'Logout profile menu item',
  },
  aiStudio: {
    id: 'staff.dashboard.menu.aiStudio',
    defaultMessage: 'AI Studio',
    description: 'AI Studio menu item',
  },
});

export default messages;